// AUTO-GENERATED by tools/i18n/generate-scope-manifest.mjs. Do not edit by hand.
// Run `npm run i18n:manifest` after adding/removing a scope folder under src/assets/i18n.

/** Every lazy Transloco scope (folder under src/assets/i18n with an en.json). */
export const I18N_SCOPES: readonly string[] = [
  'addEntity',
  'borrowerForm',
  'companies',
  'contacts',
  'dealMarketingReport',
  'dealPipeline',
  'dealsDebt',
  'dealsMisc',
  'dealsShared',
  'dealsSharedExtra',
  'externalIntegrations',
  'globalSearch',
  'home',
  'indexRateLockForm',
  'intel',
  'interactionsSearch',
  'investmentSalesDetails',
  'investmentSalesRcm',
  'investmentSalesStages',
  'loanstageTracking',
  'managePreferences',
  'mergeTool',
  'offersGrid',
  'properties',
  'protectedCompanies',
  'queryTool',
  'quotes',
  'quotesGrid',
  'revenueForm',
  'rms',
  'settings',
  'sharedComponents',
  'sharedDialogs',
  'sharedForms',
  'sharedInputs',
  'sharedNav',
  'sharedTypeaheads',
];
